export interface LanguageOption {
  code: string;
  label: string;
  native: string;
  script: string;
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'en', label: 'English', native: 'English', script: 'Latn' },
  { code: 'sa', label: 'Sanskrit', native: 'संस्कृतम्', script: 'Deva' },
  { code: 'hi', label: 'Hindi', native: 'हिन्दी', script: 'Deva' },
  { code: 'hi-Latn', label: 'Hinglish', native: 'Hinglish', script: 'Latn' },
  { code: 'pa', label: 'Punjabi', native: 'ਪੰਜਾਬੀ', script: 'Guru' },
  { code: 'gu', label: 'Gujarati', native: 'ગુજરાતી', script: 'Gujr' },
  { code: 'mr', label: 'Marathi', native: 'मराठी', script: 'Deva' },
  { code: 'bn', label: 'Bengali', native: 'বাংলা', script: 'Beng' },
  { code: 'ta', label: 'Tamil', native: 'தமிழ்', script: 'Taml' },
  { code: 'te', label: 'Telugu', native: 'తెలుగు', script: 'Telu' },
  { code: 'kn', label: 'Kannada', native: 'ಕನ್ನಡ', script: 'Knda' },
  { code: 'ml', label: 'Malayalam', native: 'മലയാളം', script: 'Mlym' },
  { code: 'or', label: 'Odia', native: 'ଓଡ଼ିଆ', script: 'Orya' }
];

// Pure Shastric Sanskrit Nomenclature
export const PLANETS_SA: Record<string, string> = {
  Sun: 'सूर्यः',
  Moon: 'चन्द्रः',
  Mars: 'मङ्गलः',
  Mercury: 'बुधः',
  Jupiter: 'गुरुः',
  Venus: 'शुक्रः',
  Saturn: 'शनिः',
  Rahu: 'राहुः',
  Ketu: 'केतुः',
  Ascendant: 'लग्नम्',
  Lagna: 'लग्नम्',
  Uranus: 'इन्द्रः',
  Neptune: 'वरुणः',
  Pluto: 'यमः'
};

export const ZODIAC_SA: Record<string, string> = {
  Aries: 'मेषः',
  Taurus: 'वृषभः',
  Gemini: 'मिथुनम्',
  Cancer: 'कर्कः',
  Leo: 'सिंहः',
  Virgo: 'कन्या',
  Libra: 'तुला',
  Scorpio: 'वृश्चिकः',
  Sagittarius: 'धनुः',
  Capricorn: 'मकरः',
  Aquarius: 'कुम्भः',
  Pisces: 'मीनः'
};

export const TERMS_SA: Record<string, string> = {
  Tithi: 'तिथिः',
  Sunrise: 'सूर्योदयः',
  Sunset: 'सूर्यास्तः',
  RahuKaal: 'राहुकालः',
  Abhijit: 'अभिजित् मुहूर्तम्',
  Nakshatra: 'नक्षत्रम्',
  Yoga: 'योगः',
  Karana: 'करणम्',
  Vaara: 'वासरः',
  Paksha: 'पक्षः'
};

// Gurmukhi Punjabi Jyotish Nomenclature
export const PLANETS_PA: Record<string, string> = {
  Sun: 'ਸੂਰਜ',
  Moon: 'ਚੰਦਰਮਾ',
  Mars: 'ਮੰਗਲ',
  Mercury: 'ਬੁੱਧ',
  Jupiter: 'ਗੁਰੂ (ਬ੍ਰਹਸਪਤੀ)',
  Venus: 'ਸ਼ੁੱਕਰ',
  Saturn: 'ਸ਼ਨੀ',
  Rahu: 'ਰਾਹੂ',
  Ketu: 'ਕੇਤੂ',
  Ascendant: 'ਲਗਨ',
  Lagna: 'ਲਗਨ'
};

export const ZODIAC_PA: Record<string, string> = {
  Aries: 'ਮੇਖ',
  Taurus: 'ਬ੍ਰਿਖ',
  Gemini: 'ਮਿਥੁਨ',
  Cancer: 'ਕਰਕ',
  Leo: 'ਸਿੰਘ',
  Virgo: 'ਕੰਨਿਆ',
  Libra: 'ਤੁਲਾ',
  Scorpio: 'ਬ੍ਰਿਸ਼ਚਕ',
  Sagittarius: 'ਧਨੁ',
  Capricorn: 'ਮਕਰ',
  Aquarius: 'ਕੁੰਭ',
  Pisces: 'ਮੀਨ'
};

export const TERMS_PA: Record<string, string> = {
  Tithi: 'ਤਿਥੀ',
  Sunrise: 'ਸੂਰਜ ਚੜ੍ਹਨਾ',
  Sunset: 'ਸੂਰਜ ਡੁੱਬਣਾ',
  RahuKaal: 'ਰਾਹੂ ਕਾਲ',
  Abhijit: 'ਅਭਿਜੀਤ ਮੁਹੂਰਤ',
  Nakshatra: 'ਨਕਸ਼ਤਰ',
  Yoga: 'ਯੋਗ',
  Karana: 'ਕਰਨ',
  Vaara: 'ਵਾਰ',
  Paksha: 'ਪੱਖ'
};
